module.exports = __webpack_public_path__ + "img/pantalla-3-2.09ecbd88.png";